module.exports = __webpack_public_path__ + "static/media/felixfund.3a837dd5.png";